import Vue from "vue";

const status = [
    { 
        text: 'Gerado',
        color: 'purple',
        dark: true,
        value: 'generated' 
    },
    { 
        text: 'Editado', 
        color: 'blue',
        dark: true,
        value: 'edited' 
    },
    { 
        text: 'Publicado', 
        color: 'green',
        dark: true,
        value: 'published' 
    },
    { 
        text: 'Pendente', 
        value: 'pending',
        color: 'yellow',
    },
    { 
        text: 'Falhou', 
        color: 'red',
        dark: true,
        value: 'failed' 
    }
]

export const $socialPost = {
    status
}

Vue.prototype.$socialPost = $socialPost;